/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_Create_TitleInputs */

const cs_links_create_title = /** @type {(inputs: Links_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový odkaz`)
};

const en_links_create_title = /** @type {(inputs: Links_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New link`)
};

/**
* | output |
* | --- |
* | "New link" |
*
* @param {Links_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_create_title = /** @type {((inputs?: Links_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_create_title(inputs)
	return cs_links_create_title(inputs)
});